import { Box, Typography, LinearProgress } from '@mui/material';
import { EmptyState } from './EmptyState';

export interface BarDatum {
  label: string;
  value: number;
  color?: string;
}

/** Lightweight horizontal bar chart (dependency-free) for small dashboards. */
export function MiniBarChart({ data, valueFormatter }: { data: BarDatum[]; valueFormatter?: (v: number) => string }) {
  const max = Math.max(1, ...data.map((d) => d.value));
  const nonZero = data.filter((d) => d.value > 0);
  if (nonZero.length === 0) return <EmptyState title="No data yet" dense />;

  const fmt = valueFormatter ?? ((v: number) => String(v));

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
      {data.map((d) => (
        <Box key={d.label}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.25 }}>
            <Typography variant="caption" color="text.secondary" sx={{ textTransform: 'capitalize' }}>
              {d.label.replace(/_/g, ' ')}
            </Typography>
            <Typography variant="caption" fontWeight={700}>{fmt(d.value)}</Typography>
          </Box>
          <LinearProgress
            variant="determinate"
            value={(d.value / max) * 100}
            sx={{ height: 8, borderRadius: 5, bgcolor: 'action.hover', '& .MuiLinearProgress-bar': { borderRadius: 5, backgroundColor: d.color } }}
          />
        </Box>
      ))}
    </Box>
  );
}
